import React, { useEffect } from 'react';
import { Platform, StatusBar, StyleSheet, View } from 'react-native';
import * as NavigationBar from 'expo-navigation-bar';
import { useTheme } from '../../theme/ThemeContext';
import AppLogo from './AppLogo';

const LIGHT_SPLASH_BACKGROUND = '#F3F2EF';
const DARK_SPLASH_BACKGROUND = '#000000';

type BrandSplashProps = {
  animateOut?: boolean;
  onFinish?: () => void;
};

const BrandSplash = ({ animateOut = false, onFinish }: BrandSplashProps) => {
  const { isDark } = useTheme();
  const splashBackground = isDark ? DARK_SPLASH_BACKGROUND : LIGHT_SPLASH_BACKGROUND;
  const barStyle = isDark ? 'light-content' : 'dark-content';
  const navigationButtonStyle = isDark ? 'light' : 'dark';

  useEffect(() => {
    StatusBar.setBarStyle(barStyle, false);

    if (Platform.OS === 'android') {
      StatusBar.setBackgroundColor(splashBackground, false);
      NavigationBar.setBackgroundColorAsync(splashBackground);
      NavigationBar.setButtonStyleAsync(navigationButtonStyle);
    }

    if (animateOut) {
      onFinish?.();
    }
  }, [animateOut, barStyle, navigationButtonStyle, onFinish, splashBackground]);

  return (
    <View
      style={[
        styles.container,
        styles.fillScreen,
        { backgroundColor: splashBackground },
      ]}
    >
      <AppLogo width={180} height={101} style={styles.logo} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    zIndex: 99,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fillScreen: {
    flex: 1,
  },
  logo: {
    maxWidth: 180,
    aspectRatio: 1672 / 941,
  },
});

export default BrandSplash;
